import {SelectItem} from '@/store/types';

export interface StatisticState {
    mnStatisticDetail?: any,
    mnStatisticGroup?: any,
    mnGroupings: {
        mnGroup: string[],
        mnGroupOptionally: string[],
    },
}

export class GroupFilterParams {
    message_direction:string = 'mt';
    date_from: string;
    date_to: string;
    group_by: string;
    template_id?: number|null = undefined;
    bulk_id?: number|null = undefined;
    message_type?: string|null = undefined
    mn_service_name?: string = undefined
    mn_tmpl?: string = undefined;
    routes?: string = undefined;

    constructor(date_from: string, date_to: string, group_by: string) {
        this.date_from = date_from;
        this.date_to = date_to;
        this.group_by = group_by;
    }
}

export interface GroupItem {
    date?: string|any;
    originator?: string;
    service_provider?: string;
    partner?: string;
    recipient_operator?: string;
    template_id?: string;
    bulk_id?: string;
    Finished?: number;
    NotAnswered?: number;
    Error?: number;
    Rejected?: number;
    Deferred?: number;
    CallsCount?: number;
    Charged?: string;
}

export class DetailFilterParams {
    message_direction:string = 'mt';
    date_from: string;
    date_to: string;
    mn_service_name?: string = undefined;
    mn_tmpl?: string = undefined;
    routes?: string = undefined;
    recipient?: number = undefined;
    status?: string = undefined;
    template_id?: number = undefined;
    bulk_id?: number = undefined;
    message_type?: string = undefined;
    ext_id1?: string = undefined;
    ext_id2?: string = undefined;
    ext_id3?: string = undefined;
    ext_id4?: string = undefined;
    ext_id5?: string = undefined;
    page_number: number = 1;

    constructor(date_from: string, date_to: string) {
        this.date_from = date_from;
        this.date_to = date_to;
    }
}

export interface DetailItem {
    date_from: string,
    originator: string,
    recipient: string,
    partner: string,
    service_provider: string,
    content: string,
    status: string,
    error_code: number|null,
  }

export interface IDetailFilterParams {
    date_from: string | null,
    date_to: string | null,
    originator?: string | null,
    recipient?: number | null,
    partner?: string | null,
    service_provider?: string | null,
    status?: string | null,
    message_category?: string | null,
    error_code?: string | null,
    message_type?: string | null,
    message?: string | null,
    sent_date_from?: string | null,
    sent_date_to?: string | null,
    deliver_date_from?: string | null,
    deliver_date_to?: string | null,
    template_id?: string | null,
    bulk_id?: string | null,
    operator?: string | null,
    broker_account_login?: string | null,
    partner_user_login?: string | null,
    id?: string | null,
    smpp_id?: string | null,
    external_id?: string | null,
    ext_id1?: string | null,
    ext_id2?: string | null,
    ext_id3?: string | null,
    ext_id4?: string | null,
    ext_id5?: string | null,
}

export interface MailNotifyDetailItemInfo {
    broker_account_login: null | string,
    bulk_id: number | null,
    template_id: number | null,
    id: string,
    message: string,
    message_parts: number | null,
    originator: string,
    partner_user_login: string,
    partner_price: null | string,
    recipient: string,
    country: string,
    operator: string,
    status: string,
    sent_date: string | null,
    connection_type: string | null,
    ext_id1?: string | null,
    ext_id2?: string | null,
    ext_id3?: string | null,
    ext_id4?: string | null,
    ext_id5?: string | null,
}

